import { render } from "./timeDisplaySize.vue?vue&type=template&id=84a8fe34&scoped=true"
import script from "./timeDisplaySize.vue?vue&type=script&lang=js"
export * from "./timeDisplaySize.vue?vue&type=script&lang=js"

import "./timeDisplaySize.vue?vue&type=style&index=0&id=84a8fe34&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a8fe34"]])

export default __exports__